"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Section = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const utils_1 = require("../utils");
const styled_system_1 = require("../utils/styled-system");
const getPaddingDimensions = (padding) => {
    switch (padding) {
        case 'compact':
            return { mobilePadding: 24, desktopPadding: 32 };
        case 'spacey':
            return { mobilePadding: 64, desktopPadding: 96 };
        case 'spacier':
            return { mobilePadding: 80, desktopPadding: 160 };
        default:
            return { mobilePadding: 40, desktopPadding: 64 };
    }
};
exports.Section = styled_1.default.section((props) => {
    const { mobilePadding, desktopPadding } = getPaddingDimensions(props.spacing);
    return {
        ...(0, styled_system_1.layout)(props),
        background: props.background,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        ...(0, styled_system_1.background)(props),
        ...(0, styled_system_1.border)(props),
        color: props.color,
        display: 'flex',
        flexDirection: 'column',
        ...(0, styled_system_1.overflow)(props),
        paddingBottom: mobilePadding,
        paddingTop: mobilePadding,
        position: 'relative',
        userSelect: props.noSelect ? 'none' : undefined,
        ...(0, styled_system_1.flexbox)(props),
        ...(0, styled_system_1.grid)(props),
        ...(0, styled_system_1.typography)(props),
        ...(0, styled_system_1.space)(props),
        [(0, utils_1.mediaBreakpointGte)('md')]: {
            paddingBottom: desktopPadding,
            paddingTop: desktopPadding,
            ...(0, styled_system_1.space)(props),
        },
    };
});
